<template>
	<el-dialog title="监理资料交接清单" :close-on-click-modal="false" :visible.sync="visible" width="400px"
		top="calc(5vh - 40px)" class="handover-dialog">
		<!-- 自定义标题区域 -->
		<template slot="title">
			<div class="dialog-title-wrapper">
				<span class="dialog-title-text">监理资料交接清单</span>
				<el-button type="primary" size="mini" class="save-btn" @click="saveSortOrder" :loading="saveLoading"
					:disabled="recordList.length == 0">
					排序保存
				</el-button>
			</div>
		</template>
		<el-row class="dialog-content">
			<el-table :row-class-name="tableRowClassName" ref="dataListTable" class="dataListTable" :data="recordList"
				header-align="center" :max-height="tableMaxHeight" style="width: 100%; margin-top: 0px;"
				header-cell-class-name="dataListTHeader" :cell-style="{ padding: '3px 0' }">
				<el-table-column type="index" label="NO." width="60" align="center">
					<template slot-scope="scope">{{ (pageIndex2 - 1) * pageSize + scope.$index + 1 }}</template>
				</el-table-column>
				<el-table-column prop="fileName" label="案卷名称" header-align="center" align="left" show-overflow-tooltip>
					<template slot-scope="scope">
						<el-button v-preventReClick type="text" size="small" style="font-size: 12px; padding: 0;"
							@click="viewPdf(scope.row.templatePath, scope.row.templatePathUri, scope.row.fileName)">{{
								scope.row.fileName }}</el-button>
					</template>
				</el-table-column>
				<el-table-column label="排序" width="80" align="center">
					<template slot-scope="scope">
						<el-input v-model="scope.row.showSort" class="sp-input"></el-input>
					</template>
				</el-table-column>
				<el-table-column label="" header-align="center" align="center" width="100">
					<template slot-scope="scope">
						<el-button v-preventReClick type="text" size="small" style="font-size: 12px; padding: 0;"
							@click="removeHandle(scope.row.recId)">移出</el-button>
						<el-button v-preventReClick type="text" size="small" style="font-size: 12px; padding: 0;"
							@click="downLoadFile(scope.row.templatePathUri, scope.row.fileName)">下载</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination class="my-pagination" @size-change="sizeChangeHandle" @current-change="currentChangeHandle"
				:current-page="pageIndex" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage"
				layout="total, sizes, prev, pager, next, jumper">
			</el-pagination>
		</el-row>

		<view-pdf v-if="viewPdfVisible" ref="viewPdf"></view-pdf>

	</el-dialog>
</template>

<script>
import $common from "@/utils/common.js"
import ViewPdf from "../projectInfo/viewPdf.vue"
export default {
	name: "project-kind-setting",
	data() {
		return {
			action: "",
			//当前页码
			pageIndex: 1,
			//当前记录数
			pageSize: 20,
			totalPage: 0,
			visible: false,
			viewPdfVisible: false,
			saveLoading: false,
			dataForm: {
			},
			recordList: [],
			tableMaxHeight: 620, // 动态计算表格最大高度
			dataRule: {
			},
		}
	},
	components: {
		ViewPdf,
	},
	mounted() {
		this.calculateTableMaxHeight();
	},
	methods: {
		calculateTableMaxHeight() {
			this.tableMaxHeight = 620;
		},
		init() {
			// this.dataForm.nodeId = id || 0;
			this.visible = true;
			if (this.$refs["dataForm"]) {
				this.$refs["dataForm"].resetFields()
			}
			this.dataForm = {
				workNo: $common.getItem("workNo"),
			}
			this.getList()
		},
		getList() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/projecthandoverlist/list",
				method: "get",
				params: this.$http.adornParams({
					limit: this.pageSize,
					page: this.pageIndex,
					workNo: $common.getItem("workNo"),
					// fileName: this.fileName,
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.recordList = data.body.records
					this.totalPage = data.body.totalCount;
					this.pageIndex2 = this.pageIndex
				}
			});
		},
		// 表单提交
		removeHandle(recId) {
			this.$http({
				url: this.$store.state.httpUrl + `/business/projecthandoverlist/delete/` + recId,
				method: "post",
				data: {}
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: '操作成功',
						type: 'success',
						duration: 1500,
						onClose: () => {
							this.getList()
						}
					})
				}
			});
		},
		// 新增保存排序方法
		saveSortOrder() {
			this.saveLoading = true;

			this.$http({
				url: this.$store.state.httpUrl + "/business/projecthandoverlist/batchUpdateShowSort",
				method: "post",
				data: this.$http.adornData({
					records: this.recordList
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: '排序保存成功',
						type: 'success',
						duration: 1500
					});
					this.getList()
				}
			}).finally(() => {
				this.saveLoading = false;
			});
		},
		// 每页数
		sizeChangeHandle(val) {
			this.pageSize = val
			this.pageIndex = 1
			this.getList()
		},
		// 当前页
		currentChangeHandle(val) {
			if (val) {
				this.pageIndex = val
			} else {
				this.pageIndex = 1
			}
			this.getList()
		},
		tableRowClassName({ row, rowIndex }) {
			return $common.tableRowClassName({ row, rowIndex });
		},
		downLoadFile(fileUri, filename) {
			filename = this.getSuffix(fileUri, filename)
			this.getBlob(fileUri, (blob) => {
				this.saveAs(blob, filename)
			})
		},
		viewPdf(filePath, fileUri, filename) {
			// pdf和doc文件，需要pdf在线预览，其他类型文件直接下载
			let suffixType = fileUri.substr(fileUri.lastIndexOf(".") + 1)
			if (suffixType != '' && (suffixType === 'pdf' || suffixType === 'doc' || suffixType === 'docx')) {
				this.viewPdfVisible = true;
				this.$nextTick(() => {
					this.$refs.viewPdf.init(filename, filePath)
				})
			} else {
				filename = this.getSuffix(fileUri, filename)
				this.getBlob(fileUri, (blob) => {
					this.saveAs(blob, filename)
				})
			}
		},
		getSuffix(url, filename) {
			let lastIndex = url.lastIndexOf(".");
			return filename + url.substr(lastIndex)
		},
		getBlob(url, cb) {
			var xhr = new XMLHttpRequest()
			xhr.open('GET', url, true)
			xhr.responseType = 'blob'
			xhr.onload = function () {
				if (xhr.status === 200) {
					cb(xhr.response)
				}
			}
			xhr.send()
		},
		saveAs(blob, filename) {
			if (window.navigator.msSaveOrOpenBlob) {
				navigator.msSaveBlob(blob, filename)
			}
			else {
				var link = document.createElement('a')
				var body = document.querySelector('body')

				link.href = window.URL.createObjectURL(blob)
				link.download = filename

				link.style.display = 'none'
				body.appendChild(link)

				link.click()
				body.removeChild(link)
				window.URL.revokeObjectURL(link.href)
			}
		},
	}
}
</script>
<style lang="scss" scoped>
/* 紧凑对话框样式 */
.handover-dialog {
	:deep(.el-dialog) {
		/* 固定对话框总高度 */
		height: 680px !important;
		max-height: 690px !important;
		min-height: 690px !important;
		/* 固定宽度800px */
		width: 600px !important;

		/* 让对话框垂直居中显示 */
		position: absolute !important;
		top: 50% !important;
		left: 50% !important;
		transform: translate(-50%, -50%) !important;
		margin: 0 !important;

		/* 确保对话框不会超出屏幕 */
		overflow: hidden !important;
		display: flex !important;
		flex-direction: column !important;
	}

	:deep(.el-dialog__header) {
		padding: 8px 20px !important;
		height: 36px !important;
		min-height: 36px !important;
		flex-shrink: 0;
		box-sizing: border-box;
		border-bottom: 1px solid #e4e7ed !important;
		position: relative !important;

		/* 隐藏默认标题 */
		.el-dialog__title {
			display: none !important;
		}

		/* 调整关闭按钮位置，与标题水平对齐 */
		.el-dialog__headerbtn {
			top: 5px !important;
			/* 调整上边距，与标题对齐 */
			right: 10px !important;
			font-size: 14px !important;
			height: 20px !important;
			width: 20px !important;

			.el-icon-close {
				font-size: 14px !important;
			}
		}
	}

	/* 自定义标题区域样式 */
	.dialog-title-wrapper {
		display: flex !important;
		align-items: center !important;
		height: 20px !important;
		line-height: 20px !important;
		width: 100% !important;
		position: relative !important;

		.dialog-title-text {
			font-size: 15px !important;
			font-weight: bold !important;
			color: #303133 !important;
			position: absolute !important;
			left: 0 !important;
			top: 0 !important;
			line-height: 20px !important;
		}

		.save-btn {
			position: absolute !important;
			right: 50px !important;
			top: 1px !important;
			/* 微调垂直位置 */
			height: 22px !important;
			min-height: 22px !important;
			line-height: 20px !important;
			padding: 0 8px !important;
			font-size: 11px !important;
			border-radius: 2px !important;
			z-index: 10 !important;
			background-color: #036EC2;

			&:hover {
				opacity: 0.9;
			}
		}
	}

	:deep(.el-dialog__body) {
		flex: 1 !important;
		padding: 0px 20px 0px 20px !important;
		overflow: hidden !important;
		display: flex !important;
		flex-direction: column !important;
		height: calc(100% - 36px) !important;
		min-height: 0 !important;
		box-sizing: border-box !important;
	}

	:deep(.el-dialog__footer) {
		display: none !important;
	}
}

/* 对话框内容区域 */
.dialog-content {
	flex: 1 !important;
	display: flex !important;
	flex-direction: column !important;
	height: 100% !important;
	min-height: 0 !important;
	margin: 0 !important;
	padding: 0 !important;

	/* 表格区域 */
	.dataListTable {
		flex: 1 !important;
		min-height: 0 !important;
		height: calc(100% - 44px) !important;
		/* 调整：100% - 分页高度(24px) - 上下margin(20px) */
		overflow: hidden !important;

		:deep(.el-table) {
			height: 100% !important;

			.el-table__body-wrapper {
				overflow-y: auto !important;
			}

			.el-table__empty-block {
				min-height: 520px !important;
				height: 520px !important;
				display: flex;
				align-items: center;
				justify-content: center;
			}
		}

		:deep(.el-table__row) {
			height: 28px !important;
		}

		:deep(.el-table__header) {
			th {
				font-size: 11px !important;
				padding: 4px 0 !important;
				height: 28px !important;
				font-weight: 600;
			}
		}

		:deep(.el-table__body) {
			td:nth-child(3) {
				/* 第3列：排序列 */
				padding: 0 !important;

				.cell {
					padding: 0 !important;
					line-height: 1 !important;
					height: 28px !important;
					/* 与行高一致 */
					display: flex !important;
					justify-content: center !important;
					align-items: center !important;

					.sp-input {
						margin: -2px 0 !important;
						/* 减少上下间距 */
					}
				}
			}

			td {
				font-size: 11px !important;
				padding: 2px 0 !important;
				line-height: 1.2;
			}
		}

		:deep(.el-button--text) {
			font-size: 11px !important;
			padding: 0 4px !important;
		}

		:deep(.el-table__cell) {
			padding: 0 !important;

			.cell {
				padding: 2px 0 !important;
				line-height: 1.2;
			}
		}
	}

	/* 分页组件 - 增加上下margin */
	.my-pagination {
		flex-shrink: 0 !important;
		height: 24px !important;
		min-height: 24px !important;
		max-height: 24px !important;
		width: 100% !important;
		display: flex !important;
		justify-content: flex-end !important;
		align-items: center !important;
		padding: 0 !important;
		margin: 5px 0 5px 0 !important;
		/* 上下margin各10px */
		box-sizing: border-box !important;

		/* 分页样式 */
		:deep(.el-pagination) {
			height: 24px !important;
			min-height: 24px !important;
			max-height: 24px !important;
			padding: 0 !important;
			margin: 0 !important;
			line-height: 24px !important;

			.el-pagination__total,
			.el-pagination__sizes,
			.el-pagination__jump,
			.el-pagination__editor {
				font-size: 9px !important;
				height: 22px !important;
				line-height: 22px !important;
				margin: 0 !important;
				padding: 0 !important;
			}

			.el-pagination__total {
				margin-right: 4px !important;
			}

			.el-pagination__sizes {
				margin: 0 4px 0 0 !important;

				.el-input {
					height: 22px !important;
					line-height: 22px !important;

					.el-input__inner {
						height: 22px !important;
						line-height: 22px !important;
						font-size: 10px !important;
						padding: 0 4px !important;
						border-radius: 2px !important;
					}
				}
			}

			.btn-prev,
			.btn-next {
				height: 22px !important;
				width: 22px !important;
				min-width: 22px !important;
				line-height: 22px !important;
				margin: 0 1px !important;
				padding: 0 !important;
				font-size: 10px !important;
				border-radius: 2px !important;
			}

			.el-pager {
				height: 22px !important;
				line-height: 22px !important;
				margin: 0 !important;
				padding: 0 !important;

				li {
					height: 22px !important;
					line-height: 22px !important;
					min-width: 22px !important;
					margin: 0 1px !important;
					padding: 0 !important;
					font-size: 10px !important;
					border-radius: 2px !important;
				}
			}

			.el-pagination__jump {
				margin-left: 4px !important;

				.el-input {
					height: 22px !important;
					line-height: 22px !important;

					.el-input__inner {
						height: 22px !important;
						line-height: 22px !important;
						font-size: 10px !important;
						padding: 0 4px !important;
						width: 35px !important;
						border-radius: 2px !important;
					}
				}
			}
		}
	}
}

:deep(.sp-input) {
	width: 60px !important;
	height: 24px !important;
	/* 增加高度 */
	min-height: 24px !important;
	max-height: 24px !important;
	margin: 0 !important;
	padding: 0 !important;
	display: inline-block !important;
	vertical-align: middle !important;

	.el-input {
		width: 100% !important;
		height: 100% !important;
	}

	.el-input__inner {
		width: 60px !important;
		height: 24px !important;
		/* 增加内部高度 */
		min-height: 24px !important;
		max-height: 24px !important;
		line-height: 24px !important;
		/* 调整行高 */
		padding: 0 4px !important;
		font-size: 11px !important;
		border-radius: 2px !important;
		border: 1px solid #DCDFE6 !important;
		background-color: #fff !important;
		text-align: center !important;
		box-sizing: border-box !important;

		&:focus {
			border-color: #409EFF !important;
			outline: none !important;
			box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1) !important;
		}

		&:hover {
			border-color: #C0C4CC !important;
		}
	}

	/* 隐藏可能的前后缀图标 */
	.el-input__suffix,
	.el-input__prefix {
		display: none !important;
	}

	.el-input__suffix-inner,
	.el-input__prefix-inner {
		display: none !important;
	}
}
</style>
